module.exports = __webpack_public_path__ + "img/hr-dead-grey-trunk-00.c92088d0.png";